import React from "react";
import { useIntl } from 'umi';
import styles from './index.module.scss';

interface IProps {
  failedMsg?: string;
}

const LoadingFailed = (props: IProps) => {
  const { formatMessage } = useIntl(); 
  const { failedMsg = formatMessage({ id: 'common_loading_failed' }) } = props;
  return <div className={styles.loadingFailedBox}>{failedMsg}</div>;
};

export default LoadingFailed;